import { types } from './actions';

const initialState = {
  isSesVerificationFailureModalOpen: false,
};

const reducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case types.SES_VERIFICATION_FAILURE_MODAL_CLOSE:
      return {
        ...state,
        isSesVerificationFailureModalOpen: false,
      };
    case types.SES_VERIFICATION_FAILURE_MODAL_OPEN:
      return {
        ...state,
        isSesVerificationFailureModalOpen: true,
      };
    default:
      return state;
  }
};

export const getScope = (state) =>
  state.modules.common.modals.sesVerificationFailureModal;

export const isSesVerificationFailureModalOpen = (state) =>
  getScope(state).isSesVerificationFailureModalOpen;

export default reducer;
